module.exports = __webpack_public_path__ + "media/brands/compair-84848200.png";